import { Deserializable } from "./deserializable";
import { Price } from "./price";


export class Quantity implements Deserializable{
    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
    unit: string;
    quantity: number;
}
